var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_887",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "url(#pattern0_0_887)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_887)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.09998,
    y: -2.79999,
    width: 16.1,
    height: 18.9,
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_0_887",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_887",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_887",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.f89c0edd12752c9ec0f94317aa0d43a7.svg";
export { ForwardRef as ReactComponent };